export const environment = {
  production: false,
  productLogoLarge: 'assets/images/smart-menu-logo.svg',
  // serverUrl: 'https://dev2.optimusai.ai/',
  serverUrl: 'https://sm-api-gateway-service-dev.optimusai.ai/',
  supportEmail: 'support@smartmenu.com',
  payazaPublicKey: 'PZ78-PKTEST-218C826C-84FD-4202-88A5-FD579485C2BD',
  showFeature: true,
};
